import * as React from 'react';
import { observer, inject } from "mobx-react";

// =====================================
// STORES
import { IOrdersStore } from '../../store/OrdersStore';

// =====================================
// COMPONENTS
import { Loader } from '../Layout/Loader';
import NewOrderArticles from './NewOrderArticles';
import NewOrderDetails from './NewOrderDetails';
import NewOrderArticlesPriceChange from './NewOrderArticlesPriceChange';

@inject((allStores: any) => ({
    ordersStore: allStores.store.ordersStore as IOrdersStore
}))

@observer
export default class EditOrder extends React.Component<{ ordersStore?: IOrdersStore; match?: any }, {}> {

    componentDidMount() {
        const customerId = this.props.match?.params?.customerId;
        const orderId = this.props.match?.params?.orderId;
        this.props.ordersStore.getOrderByIdForEdit(customerId, orderId);
    }

    componentWillUnmount() {
        this.props.ordersStore.reset();
    }

    render() {

        if (this.props.ordersStore.isLoading) {
            return <Loader />;
        }

        let newOrderComponent: any = null;
        if (this.props.ordersStore.isOrderListVisible === false && this.props.ordersStore.isArticlesPriceChangeVisible === false) {
            newOrderComponent = <NewOrderArticles
                customerId={this.props.match?.params?.customerId} />
        } else if (this.props.ordersStore.isOrderListVisible === true && this.props.ordersStore.isArticlesPriceChangeVisible === false) {
            newOrderComponent = <NewOrderDetails
                customerId={this.props.match?.params?.customerId}
                orderId={this.props.match?.params?.orderId} />
        } else if (this.props.ordersStore.isOrderListVisible === false && this.props.ordersStore.isArticlesPriceChangeVisible === true) {
            newOrderComponent = <NewOrderArticlesPriceChange
                customerId={this.props.match?.params?.customerId} />
        }

        return (
            <div>
                {newOrderComponent}
            </div>
        );
    }
}